import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { LanguageState } from '../appState';
import { Resource } from '../resource';

export function useTime() {
  const actionConvertTime = {
    "month": (seconds) => {
      const months = Math.floor(seconds / 2592000)
      const days = Math.round((seconds % 2592000) / 86400)
      return {
        isMonth: true,
        month: months,
        day: days
      }
    },
    "day": (seconds) => {
      const days = Math.floor(seconds / 86400)
      const hour = Math.round((seconds % 86400) / 3600)
      return {
        isDay: true,
        day: days,
        hour: hour
      }
    },
    "hour": (seconds) => {
      const hour = Math.floor(seconds / 3600)
      const minutes = Math.round((seconds % 3600) / 60)
      return {
        isHour: true,
        hour: hour,
        minutes: minutes
      }
    },
    "minute": (seconds) => {
      const minutes = Math.floor(seconds / 60)
      const s = Math.round(seconds % 60)
      return {
        isMinute: true,
        minutes: minutes,
        second: s
      }
    },
    "second": (seconds) => {
      return {
        isSecond: true,
        second: seconds
      }
    }
  }
  const convertDuration = (seconds) => {
    if (seconds > 2592000) {
      return actionConvertTime['month']
    }

    if (seconds >= 86400) {
      return actionConvertTime["day"](seconds)
    }
    else if (seconds >= 3600) {
      return actionConvertTime["hour"](seconds)
    }
    else if (seconds >= 60) {
      return actionConvertTime["minute"](seconds)
    }
    else {
      return actionConvertTime["second"](seconds)
    }
  }
  const displayTextTime = (timeObject) => {
    if (timeObject) {
      let text = ''
      if (timeObject?.isMonth) {
        text = `${timeObject?.month} ${Resource.common.month?.toLocaleLowerCase()}`
        if (timeObject?.day > 0) {
          text += ` ${timeObject?.day} ${Resource.common.day?.toLocaleLowerCase()}`
        }
      }
      else if (timeObject?.isDay) {
        text = `${timeObject?.day} ${Resource.common.day?.toLocaleLowerCase()}`
        if (timeObject?.hour > 0) {
          text += ` ${timeObject?.hour} ${Resource.common.hour?.toLocaleLowerCase()}`
        }
      }
      else if (timeObject?.isHour) {
        text = `${timeObject?.hour} ${Resource.common.hour?.toLocaleLowerCase()}`
        if (timeObject?.minutes > 0) {
          text += ` ${timeObject?.minutes} ${Resource.common.minutes?.toLocaleLowerCase()}`
        }
      }
      else if (timeObject?.isMinute) {
        text = `${timeObject?.minutes} ${Resource.common.minutes?.toLocaleLowerCase()}`
        if (timeObject?.second > 0) {
          text += ` ${timeObject?.second} ${Resource.common.seconds?.toLocaleLowerCase()}`
        }
      }
      else {
        text = `${timeObject?.second} ${Resource.common.seconds?.toLocaleLowerCase()}`
      }
      return text
    }
  }

  const convertText = (value) => {
    let textObject = convertDuration(value)
    let text = displayTextTime(textObject)
    return text
  }
  const [timeTool, setTimeTool] = useState({
    convertTime: (value) => convertText(value)
  })
  const language = useRecoilValue(LanguageState)

  useEffect(() => {
    setTimeTool((prev) => (
      {
        ...prev,
        convertTime: (value) => convertText(value)
      }
    ))
  }, [language])

  return timeTool;
}